import * as React from "react";
import { Mutation, MutationFn } from "react-apollo";
import {
  SendWelcomeMutation,
  SendWelcomeMutationVariables
} from "../../__generated__/types";
import { SEND_WELCOME_QUERY } from "./queries";

class SendWelcome extends Mutation<SendWelcomeMutation> {}

export interface Props {
  children(
    props: MutationFn<SendWelcomeMutation, SendWelcomeMutationVariables>
  ): JSX.Element | null;
}

export interface State {}

export default class SendWelcomeMail extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <SendWelcome mutation={SEND_WELCOME_QUERY}>
        {result => this.props.children(result)}
      </SendWelcome>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/SendWelcomeMail/SendWelcomeMail.tsx